/**
 * Builds two UUID lists (previous / next) and who was added vs removed.
 *
 * Used for case list metrics. `undefined` is treated as an empty list so we never throw.
 * `addedClerkUuids` = IDs that appear in `next` but not in `previous` — including a second clerk
 * when one was already there, not only "from zero clerks to some".
 */
export function computeLegacyCaseListClerkUuidDeltas(
  previousClerkUuids: string[] | undefined | null,
  nextClerkUuids: string[] | undefined | null
): {
  normalizedPrevious: string[]
  normalizedNext: string[]
  addedClerkUuids: string[]
  removedClerkUuids: string[]
} {
  const normalizedPrevious = previousClerkUuids ?? []
  const normalizedNext = nextClerkUuids ?? []
  const addedClerkUuids = normalizedNext.filter((uuid) => !normalizedPrevious.includes(uuid))
  const removedClerkUuids = normalizedPrevious.filter((uuid) => !normalizedNext.includes(uuid))
  return { normalizedPrevious, normalizedNext, addedClerkUuids, removedClerkUuids }
}
